import { HLayout, HList } from '@sleepstation/components-layouts'
import { mq } from '@sleepstation/style-api-helpers'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { getKeyFromLinks } from '../../helpers'
import BurgerMenu from './BurgerMenu'
import TopHorizontalMenuItem from './TopHorizontalMenuItem'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(HLayout).attrs({
  spacing: 1,
  'data-cy': `top-horizontal-menu`,
})``

const LinksMenu = styled(HList).attrs({ spacing: 1 })`
  ${mq(`mediumDown`)} {
    display: none;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const TopHorizontalMenu = ({ links, menuIsOpen, setMenuIsOpen }) => (
  <Layout>
    <LinksMenu>
      {renderList(
        ({ linkUrl, iconKey, linkText, showBadge }) => (
          <TopHorizontalMenuItem
            linkUrl={linkUrl}
            iconKey={iconKey}
            linkText={linkText}
            showBadge={showBadge}
          />
        ),
        links,
        { idFunc: getKeyFromLinks(links) }
      )}
    </LinksMenu>
    <BurgerMenu menuIsOpen={menuIsOpen} setMenuIsOpen={setMenuIsOpen} />
  </Layout>
)

TopHorizontalMenu.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
  menuIsOpen: PropTypes.bool.isRequired,
  setMenuIsOpen: PropTypes.func.isRequired,
}

export default TopHorizontalMenu
